/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The enable state of the unit file.
 */
export enum SystemdEnableStateType {
  SystemdEnableStateEnabled = 'enabled',
  SystemdEnableStateEnabledRuntime = 'enabled-runtime',
  SystemdEnableStateLinked = 'linked',
  SystemdEnableStateLinkedRuntime = 'linked-runtime',
  SystemdEnableStateAlias = 'alias',
  SystemdEnableStateMasked = 'masked',
  SystemdEnableStateMaskedRuntime = 'masked-runtime',
  SystemdEnableStateStatic = 'static',
  SystemdEnableStateDisabled = 'disabled',
  SystemdEnableStateIndirect = 'indirect',
  SystemdEnableStateGenerated = 'generated',
  SystemdEnableStateTransient = 'transient',
  SystemdEnableStateBad = 'bad',
  SystemdEnableStateUnknown = 'unknown',
  SystemdEnableStateEmpty = '',
}
